import React, { useState } from 'react';
import styled from 'styled-components';

const PharmaContainer = styled.div`
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
  background: #ffffff;
`;

const PharmaIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  display: block;
`;

const LoadingMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-family: 'Inter', sans-serif;
  font-size: 1.125rem;
  z-index: 1;
  display: ${props => props.isLoading ? 'block' : 'none'};
`;

const PharmaIframeComponent = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <PharmaContainer>
      <LoadingMessage isLoading={isLoading}>
        Loading...
      </LoadingMessage>
      
      <PharmaIframe
        src="https://landing-pharma-city.vercel.app/"
        title="Pharma City"
        allowFullScreen
        loading="lazy"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        onLoad={handleIframeLoad}
      />
    </PharmaContainer>
  );
};

export default PharmaIframeComponent; 